import React from 'react'

/**
 * Edgelogbook logo mark — geometric E built from trading bar shapes
 * Uses the app's accent colours: sky blue + green
 */
export function EdgelogbookMark({ size = 32 }) {
  const s = size / 32
  return (
    <svg width={size} height={size} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="32" height="32" rx="7" fill="var(--bg-elevated)"/>
      <rect x="7" y="7" width="4" height="18" fill="var(--text-accent)"/>
      <rect x="11" y="7" width="9"  height="4" fill="var(--text-accent)"/>
      <rect x="11" y="14" width="7" height="4" fill="var(--green)"/>
      <rect x="11" y="21" width="9" height="4" fill="var(--text-accent)"/>
    </svg>
  )
}

/**
 * Full lockup: mark + wordmark
 */
export default function EdgelogbookLogo({ size = 'md', showTagline = false }) {
  const sizes = {
    sm: { mark: 24, name: 14, tag: 9 },
    md: { mark: 32, name: 17, tag: 10 },
    lg: { mark: 44, name: 22, tag: 11 },
  }
  const s = sizes[size] || sizes.md

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: s.mark * 0.35 }}>
      <EdgelogbookMark size={s.mark} />
      <div>
        <div style={{
          fontFamily: 'var(--font-mono)',
          fontSize: s.name,
          fontWeight: 700,
          letterSpacing: '0.06em',
          color: 'var(--text-primary)',
          lineHeight: 1,
          textTransform: 'uppercase',
        }}>
          <span style={{ color: 'var(--text-accent)' }}>Edge</span>
          <span>logbook</span>
        </div>
        {showTagline && (
          <div style={{
            fontFamily: 'var(--font-mono)',
            fontSize: s.tag,
            color: 'var(--text-muted)',
            letterSpacing: '0.08em',
            marginTop: 3,
            textTransform: 'uppercase',
          }}>
            Track the edge
          </div>
        )}
      </div>
    </div>
  )
}
